import { render, staticRenderFns } from "./kullaniciadiguncelle.vue?vue&type=template&id=4b11d814"
import script from "./kullaniciadiguncelle.vue?vue&type=script&lang=js"
export * from "./kullaniciadiguncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports